module.exports = "<section> <wrapper> <div class=four-o-four__container> <div class=\"h2 four-o-four__title\" translate=APP.404_TITLE></div> <p translate=APP.404_MESSAGE></p> <button class=\"button button--primary\" ui-sref=home translate=APP.BACK_HOME></button> </div> </wrapper> </section> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/four-o-four/four-o-four.template.html
// module id = 542
// module chunks = 0